export default "__VITE_ASSET__DaD7h5i0__"